import React from 'react';
import _ from "lodash";

import useStyles from './styles'
import Grid from "@material-ui/core/Grid";

import {getCheckboxListSize, isRequiredQuestion} from "../../../../../utils";
import {FIELD_REQUIRED_MSG} from "../../../../../constants";
import CheckboxFormElement from "../../formElement/CheckboxFormElement";
import CheckboxCard from "../ChecboxCardQuestion/components/CheckboxCard";
import QuestionLabel from "../../formElement/QuestionLabel";

function isQuestionValid(question, step, afterChange, service) {
  question.error = null;
  if (isRequiredQuestion(question) && _.isEmpty(question.answer)) {
    question.error = question.requiredMsg || FIELD_REQUIRED_MSG;
  }

  return !question.error;
}

function initQuestionAnswer(question, answer, force) {
  if (answer && (answer.length > 0 || force)) {
    const options = (question.config.choices || []).map(i => i.uid);
    question.answer = answer.filter(a => options.includes(a));
  }
}

function getQuestionAnswer(question) {
  return {
    question_uid: question.uid,
    answer: question.answer || [],
    multiple: true,
  }
}

export const CheckboxListQuestionMethods = {
  required: isRequiredQuestion,
  valid: isQuestionValid,
  initAnswer: initQuestionAnswer,
  answer: getQuestionAnswer,
};

const CheckboxListOption = ({classes, option, value, handleCheckboxChanged, useCard}) => {
  const CheckboxListComponent = useCard ? CheckboxCard : CheckboxFormElement;

  return (
    <CheckboxListComponent
      name={option.uid}
      label={option.text}
      info={option.info}
      value={value}
      onChange={(checked) => handleCheckboxChanged(option, _.isBoolean(checked) ? checked : !value)}
      custom_classes={{root: classes.option, label: classes.optionLabel}}
    />
  )
};

function CheckboxListQuestion(props) {

  const {
    question,
    onAnswerChange,
    noLabel,
    useCard,
  } = props;

  const classes = useStyles();

  let options = question.config.choices || [];
  const currAnswer = question.answer || [];

  const handleCheckboxChanged = (option, checked) => {
    const answer = checked ? [...currAnswer, option.uid] : _.filter(currAnswer, i => i !== option.uid);
    question.error = null; // clean error
    onAnswerChange(question.uid, answer)
  };

  const optionSize = React.useMemo(() => question.optionSize || getCheckboxListSize(question.uid), []);

  return (
    <div className={classes.inputContainer}>
      {!noLabel && !!question.question_text && (
        <div className={classes.label}>
          <QuestionLabel
            label={question.question_text}
            required={isRequiredQuestion(question) || question.required_check}
          />
        </div>
      )}
      <Grid container spacing={useCard && 1}>
        { options.map((option) => (
          <Grid item key={option.uid} sm={optionSize}>
            <CheckboxListOption
              classes={classes}
              option={option}
              value={currAnswer.includes(option.uid)}
              handleCheckboxChanged={handleCheckboxChanged}
              useCard={useCard}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default CheckboxListQuestion;